import { c as _c } from "react/compiler-runtime";
import { LinkButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { RawFenceNoticeProps, UpgradeNoticeProps } from '@/components/block-primitives/block-fence-node-view';
export const RawFenceNotice = t0 => {
  const $0 = _c(18);
  const {
    reason,
    editable,
    onDelete
  } = t0;
  let t1;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.instructionBlocks.rawFence"
    };
    $0[0] = t1;
  } else {
    t1 = $0[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  let t2;
  if ($0[1] !== reason) {
    t2 = $ => $[reason ?? "unclosed"];
    $0[1] = reason;
    $0[2] = t2;
  } else {
    t2 = $0[2];
  }
  let t3;
  if ($0[3] !== t || $0[4] !== t2) {
    t3 = t(t2);
    $0[3] = t;
    $0[4] = t2;
    $0[5] = t3;
  } else {
    t3 = $0[5];
  }
  let t4;
  if ($0[6] !== t) {
    t4 = t(_temp);
    $0[6] = t;
    $0[7] = t4;
  } else {
    t4 = $0[7];
  }
  let t5;
  if ($0[8] !== t3 || $0[9] !== t4) {
    t5 = <p>{t3} {t4}</p>;
    $0[8] = t3;
    $0[9] = t4;
    $0[10] = t5;
  } else {
    t5 = $0[10];
  }
  let t6;
  if ($0[11] !== editable || $0[12] !== onDelete || $0[13] !== t) {
    t6 = editable && <LinkButton destructive={true} onClick={onDelete} variant="caption-3">{t(_temp2)}</LinkButton>;
    $0[11] = editable;
    $0[12] = onDelete;
    $0[13] = t;
    $0[14] = t6;
  } else {
    t6 = $0[14];
  }
  let t7;
  if ($0[15] !== t5 || $0[16] !== t6) {
    t7 = <div className="mb-1 flex items-baseline gap-2 text-caption-3 text-tertiary">{t5}{t6}</div>;
    $0[15] = t5;
    $0[16] = t6;
    $0[17] = t7;
  } else {
    t7 = $0[17];
  }
  return t7;
};
export const LegacyFenceNotice = t0 => {
  const $ = _c(18);
  const {
    convertible,
    editable,
    onConvert
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.instructionBlocks.legacy"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp3);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== convertible || $[4] !== editable || $[5] !== t) {
    t3 = editable && !convertible && t(_temp4);
    $[3] = convertible;
    $[4] = editable;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <p>{t2} {t3}</p>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== convertible || $[11] !== editable || $[12] !== onConvert || $[13] !== t) {
    t5 = editable && convertible && <LinkButton onClick={onConvert} variant="caption-3">{t(_temp5)}</LinkButton>;
    $[10] = convertible;
    $[11] = editable;
    $[12] = onConvert;
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div className="mb-2 flex items-baseline gap-2 text-caption-3 text-tertiary">{t4}{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
function _temp($_0) {
  return $_0.fix;
}
function _temp2($_1) {
  return $_1.delete;
}
function _temp3($) {
  return $.notice;
}
function _temp4($_0) {
  return $_0.cannotConvert;
}
function _temp5($_1) {
  return $_1.convert;
}